// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hp-0";
export var animationContainer = "_hp-1";
export var modalContent = "_hp-2";
export var orderName = "_hp-3";
export var refundOption = "_hp-4";
export var refundOptionsContainer = "_hp-5";